import { useQuery } from "@apollo/client";
import { ChatBubbleLeftIcon } from "@heroicons/react/24/solid";
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import { useSession } from "contexts";
import { GetOrganizationDocument } from "graphql/generated";
import { useIntercom } from "react-use-intercom";

export default function IntercomChat({ type }: { type?: string }) {
    const { user, organizationType, organizationSubtype, organizationId } = useSession();
    const { update } = useIntercom();
    const { data : { organization } = {} } = useQuery(GetOrganizationDocument, { variables: { id: organizationId }, skip: !organizationId });

    if(user){
        update({
            userId: user?.id,
            email: user?.email,
            customLauncherSelector: '#intercom-launcher',    
            name: user?.firstName || user?.lastName ? (user?.firstName + ' ' + (user?.lastName ?? '')) : user?.email ?? 'New Unknown User',
            company: {
                companyId: organization?.legacyId ?? organizationId,
                name: organization?.name,
            },
            customAttributes: { version: '2.0.0', organizationSubtype, organizationType }, 
            hideDefaultLauncher: true
        }); 
    }else{
        update({
            customLauncherSelector: '#intercom-launcher',    
            hideDefaultLauncher: true
        });
    }
    if(type === 'list') {
      return (
        <div id={"intercom-launcher"} className="flex items-center border-r-4 relative cursor-pointer pl-8 h-12 font-semibold text-brand-pale border-brand-dark hover:text-white hover:bg-brand/50">
          <div className="flex items-center">
            <QuestionMarkCircleIcon className='w-5 h-5 mr-2' aria-hidden="true"/>
            <span
              className='opacity-100 transition-all ease-in-out duration-300 whitespace-nowrap'>
              Help
            </span>
          </div>
        </div>
      )
    } 
    else if (type === 'bar') {
      return <QuestionMarkCircleIcon id={"intercom-launcher"} className="h-6 w-6 pointer-events-auto"/>
    }
    else {
      return <ChatBubbleLeftIcon id={"intercom-launcher"} className="fixed md:bottom-4 bottom-[80px] right-4 h-14 w-14 text-white bg-brand-purple cursor-pointer z-[101] rounded-[100px] p-2 scale-x-[-1]" />
    }
}